module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"action.next.page":"ไปขั้นตอนถัดไป","action.sign":"ลงลายมือชื่อ","action.save":"บันทึก","cost_estimate.action.rollback.confirm.title":"ยืนยันการแก้ไขค่า","cost_estimate.action.rollback.confirm.message":"ต้องการกลับไปแก้ไขข้อมูลอะไหล่หรือไม่?"}}')
  delete Component.options._Ctor
}
